"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useMenuSplitGroupContextValues", {
    enumerable: true,
    get: function() {
        return useMenuSplitGroupContextValues;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const useMenuSplitGroupContextValues = (state)=>{
    'use no memo';
    return _react.useMemo(()=>{
        return {
            menuSplitGroup: {
                setMultiline: state.setMultiline
            }
        };
    }, [
        state.setMultiline
    ]);
};
